import {Splide} from '@splidejs/splide';
import './intersections';

document.addEventListener('DOMContentLoaded', function() {

    /**
    * Splide Slider
    */

    let splides = document.querySelectorAll('.splide');
    if(splides) {
        let opts = {
            type: 'slide',
            perPage: 5,
            focus  : 0,
            autoplay: false,
            gap: 20,
            arrows: false,
            pagination: true,
            bound: true,
            speed: 1000,
        }
        splides.forEach((i) => {
            if(i.classList.contains('reviews')) {
                opts.fixedWidth = '560px',
                opts.breakpoints = {700: {fixedWidth: '95%'}}
                console.log(opts)
            }
            if(i.classList.contains('projects')) {
                opts.fixedWidth = '250px';
            }
            if(i.getAttribute('data-perpage')) {
                opts.perPage = i.getAttribute('data-perpage');
                opts.breakPoints = {600: {fixedWidth: '100%'}}
            }
            let splideInst = new Splide(i, opts).mount();
        })
    }

    let filters = document.querySelectorAll('.filters input');
    if(filters) {
        filters.forEach((i) => i.addEventListener('change', toggleProjects));
    }

    function toggleProjects(e) {
        let value = e.target.value;
        let checked = e.target.checked;
        let filterList = [];
        filters.forEach((i) => {
            if(i.checked) {
                filterList.push(i.value);
            }
        })

        let formData = new FormData();
        formData.append('terms', filterList);
        formData.append('action', 'str_search_posts');
         fetch(sc_front.ajaxurl, {
            method: 'POST',
            body: formData
        }).then((response => response.json()))
        .then((jsonData) => {
            let success = jsonData.success;
            if(success) {
                document.querySelector('.projects-list').innerHTML = jsonData.html;
            } else {
                document.querySelector('.projects-list').innerHTML = jsonData.message;
            }
        })
        .catch((error) => {
            // e.target.parentElement.append(errorMessage)
        })

    }

    /**
     * Services List image toggle
     */

    let servicesListToggles = document.querySelectorAll('.wp-block-str-services-list summary');
    if(servicesListToggles) {
        servicesListToggles.forEach((i) => {
            i.addEventListener('click', toggleServicesListImage);
        })
    }

    function toggleServicesListImage(e) {
        let tag = e.target.getAttribute('data-tag');
        if(tag) {
            let parent = e.target.closest('.wp-block-str-services-list');
            let iamge = parent.querySelector('.image');
            setTimeout(function() {
                let images = document.querySelectorAll('.wp-block-str-services-list img');
                images.forEach((i) => {
                    i.classList.add('hidden')
                })
                document.querySelector('img[data-tag="'+tag+'"]').classList.remove('hidden');
            }, 100);
        }
    }
});